// src/pages/ReferralPage.js
import React from 'react';
import { useAuth } from '../AuthContext';

function ReferralPage() {
  const { userData } = useAuth();

  const referralCode = userData?.uid?.slice(0, 6).toUpperCase() || '------';

  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    alert('Referral code copied to clipboard!');
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">🎁 Invite Friends, Earn Rewards!</h1>

      <div className="bg-white border shadow p-4 rounded mb-6">
        <p className="mb-2">Copy and share your referral code:</p>
        <div className="flex items-center space-x-2">
          <span className="text-lg font-mono bg-gray-100 px-4 py-2 rounded">{referralCode}</span>
          <button
            onClick={handleCopy}
            className="px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Copy Code
          </button>
        </div>
        <p className="mt-3 text-sm text-gray-600">
          When your friend signs up and books their first session, you get <strong>$10 credit</strong> and they get <strong>$5 off</strong>!
        </p>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
        <h2 className="font-semibold text-blue-800 mb-2">How it works:</h2>
        <ul className="list-disc ml-5 text-sm text-gray-700">
          <li>Share your referral code with friends.</li>
          <li>They enter the code when signing up.</li>
          <li>After they upload a video and purchase a session, both of you get rewarded!</li>
        </ul>
      </div>
    </div>
  );
}

export default ReferralPage;
